import { ConnectedUser } from '@ucc/admin-global-state'
import { Roles } from '@ucc/unified-admin-common'

export const analyticsEventNames = {
  PORTAL: 'GTA > Connected user',
}

export const getIsEmployee = (iAm: ConnectedUser) => iAm?.systemRoles?.includes(Roles.SystemUser) || false

interface AnalyticsIAm {
  key: string
  accountKey?: string
  createTime?: string | number
  email?: string
  isPartner?: boolean
  firstName?: string
  lastName?: string
  locale: string
  adminRoles?: string[]
  systemRoles?: string[]
  products?: string[]
  isEmployee: boolean
}

interface iAmExtended extends ConnectedUser {
  isPartner?: boolean
  userInACustomerAccount?: boolean
  isEmployee: boolean
}

interface LicenseUtilization {
  [key: string]: number
}

export const getUserAdminRoles = (accounts, accountKey) => {
  const selectedAccount = accounts.find((account) => account.key === accountKey)
  if (selectedAccount && selectedAccount.adminRoles) {
    return selectedAccount.adminRoles
  } else {
    return 'undefined' //if we don't specify undefined, it will not overwrite the value of adminRoles from the iAm
  }
}
export const convertToAnalytics = (iAm: iAmExtended, licenseUtilization?: LicenseUtilization): AnalyticsIAm => {
  const iAmCopy = { ...iAm }

  delete iAmCopy.accounts
  delete iAmCopy.managedAccount

  let analyticsIam = iAmCopy as AnalyticsIAm

  delete analyticsIam.email
  delete analyticsIam.firstName
  delete analyticsIam.lastName
  delete analyticsIam.accountKey

  if (analyticsIam.createTime) {
    analyticsIam.createTime = new Date(analyticsIam.createTime).toISOString()
  }
  if (licenseUtilization) {
    analyticsIam = {
      ...analyticsIam,
      ...licenseUtilization,
    }
  }
  return analyticsIam
}
